import { InvoiceAdjustmentsField } from '@/components/invoice-adjustments-field';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { MultiLanguageInput } from '@/components/ui/multi-language-input';
import { Switch } from '@/components/ui/switch';
import type { GroupFormData } from '@fame/shared';
import type { Control } from 'react-hook-form';

interface GroupBillingFieldsProps {
  control: Control<GroupFormData>;
}

export function GroupBillingFields({ control }: GroupBillingFieldsProps) {
  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-sm font-medium">Facturatie</h3>
        <p className="text-sm text-muted-foreground">Prijs- en factuurinstellingen voor deze groep</p>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <FormField
          control={control}
          name="packagePrice"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Pakketprijs (pp)</FormLabel>
              <FormControl>
                <Input type="number" step="0.01" min="0" placeholder="0,00" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={control}
          name="singleRoomSupplement"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Single kamer supplement</FormLabel>
              <FormControl>
                <Input type="number" step="0.01" min="0" placeholder="0,00" {...field} value={field.value ?? ''} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <FormField
        control={control}
        name="invoiceDescription"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Factuur Omschrijving</FormLabel>
            <FormControl>
              <MultiLanguageInput placeholder="bijv. Symposium Japan" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="depositDescription"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Factuurregel Voorschot Omschrijving</FormLabel>
            <FormControl>
              <MultiLanguageInput placeholder="bijv. Voorschot" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="invoiceRemark"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Factuur Opmerking</FormLabel>
            <FormControl>
              <MultiLanguageInput placeholder="bijv. 6-14 Nov" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <InvoiceAdjustmentsField control={control} />

      <FormField
        control={control}
        name="isActive"
        render={({ field }) => (
          <FormItem className="flex items-center justify-between rounded-lg border p-4">
            <div className="space-y-0.5">
              <FormLabel className="text-base">Actief</FormLabel>
            </div>
            <FormControl>
              <Switch checked={field.value} onCheckedChange={field.onChange} />
            </FormControl>
          </FormItem>
        )}
      />
    </div>
  );
}
